module.exports = __webpack_public_path__ + "static/media/unselectedDrawHover.25563507.png";